import { Context } from "../../../context";

import { ControllerStrategy } from "../strategy";

import { TrackingControllerStrategy } from "./tracking";

export class PositionIdFollowStrategy extends TrackingControllerStrategy {
  init(context: Context): ControllerStrategy {
    super.init(context);

    if (!this.registered) {
      console.error("no controller registered");
      return this;
    }

    this.updateTracked();

    return this;
  }

  update(_deltaS: number, _gameTimeDelta: number, frameNum?: number) {
    this.updateTracked();

    if (frameNum != undefined) this.lastFrameNum = frameNum;
  }

  protected updateTracked() {
    const context = this.registered?.contextRef;
    const state = this.registered?.state;
    // NB: if the controller is set to not autoTrack, then we rely on tracked
    //     and trackedOther to be set elsewhere
    if (!context || !state || !state.autoTrack) {
      return;
    }
    const foreGround = context.world?.actors.getActor(state.positionId);
    if (foreGround) {
      state.tracked = foreGround.centroid;
    }

    const backGround = context.world?.actors.getActor(state.positionIdOther);
    if (backGround) {
      state.trackedOther = backGround.centroid;
    }
  }

  teardown() {
    super.teardown();

    if (this.registered) {
      this.registered.state.tracked = undefined;
      this.registered.state.trackedOther = undefined;
    }
  }
}
